import BaseClass from "../util/BaseClass";
import Context from "./Context";
import TrackingViews from "../aiim/tracking/TrackingViews";

export default class User extends BaseClass {

  portal;
  portalUser;
  trackingViews = new TrackingViews();

  _watchTVIntervalID = null;
  _watchTVIntervalMillis = 60000 * 10; // -1 to turn off, auto refresh interval

  canConfigureApp() {
    const item = Context.instance.configuration.appItem;
    if (item) {
      return this.canEditPortalItem(item);
    } else {
      return this.canCreateAppItem();
    }
  }

  canCreateAppItem() {
    return (this.isAdmin() || this.isPublisher());
  }

  canEditPortalItem(item) {
    const owner = item && item.owner;
    if (typeof owner === "string" && owner.length > 0 && this.portalUser) {
      if (this.isAdmin()) return true;
      if (owner === this.getUsername() && this.isPublisher()) {
        return true;
      }
    }
    return false;
  }

  getDisplayName() {
    const user = this.portalUser;
    if (user) {
      /* TODO should we display full name?
      if (typeof user.fullName === "string" && user.fullName.length > 0) {
        return user.fullName;
      } else {
        return user.username;
      }
      */
      return user.username;
    }
    return null;
  }

  getFullName() {
    if (this.portalUser) {
      return this.portalUser.fullName;
    }
    return null;
  }

  getEmail() {
    if (this.portalUser) {
      const email = this.portalUser.email;
      if (typeof email === "string" && email.length > 0) {
        return email;
      }
    }
    return null;
  }

  getUnit() {
    const lib = Context.getInstance().lib;
    let unit = "metric";
    if (lib.dojo.kernel.locale === "en-us"){
      unit = "non-metric";
    }
    return unit;
  }

  getUsername() {
    if (this.portalUser) {
      return this.portalUser.username;
    }
    return null;
  }

  isAdmin() {
    const r = this.portalUser && this.portalUser.role;
    if (r === "org_admin" || r === "account_admin") return true;
    return false;
  }

  isAnonymous() {
    return (!this.portalUser);
  }

  isDataEdit(){
    const privileges = this.portalUser && this.portalUser.privileges;
    if(privileges && privileges.length >0) {
      for (let i=0;i< privileges.length; i++){
        if(privileges[i] === "features:user:edit")
          return true;
      }
    }
    return false;
  }

  isFullDataEdit(){
    const privileges = this.portalUser && this.portalUser.privileges;
    if(privileges && privileges.length >0) {
      for (let i=0;i< privileges.length; i++){
        if(privileges[i] === "features:user:fullEdit")
          return true;
      }
    }
    return false;
  }

  isPublisher() {
    if (this.isAdmin()) return true;
    const r = this.portalUser && this.portalUser.role;
    if (r === "org_publisher" || r === "account_publisher") return true;
    return false;
  }

  setPortal(portal) {
    this.portal = portal;
    if (portal && portal.user) {
      this.portalUser = portal.user;
      // if (!Context.getInstance().uiMode.isKiosk) {
      //   this.trackingViews.load(this.portal,this.portalUser);
      //   this._watchTrackingViews();
      // } else {
      //   this.trackingViews = new TrackingViews();
      // }
      this.trackingViews.load(this.portal,this.portalUser);
      this._watchTrackingViews();
    } else {
      this.portalUser = null;
      this.trackingViews = new TrackingViews();
    }
  }

  _watchTrackingViews() {
    clearInterval(this._watchTVIntervalID);
    if (this.trackingViews && this.portal && this.portal.user) {
      const millis = this._watchTVIntervalMillis;
      if (millis >= 10000) {
        this._watchTVIntervalID = setInterval(() => {
          this.trackingViews.load(this.portal,this.portalUser);
        },millis);
      }
    }
  }

}
